<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { getRecentVisits } from "@/utils/micoapp-recent";

export default {
  components: { Layout, PageHeader },
  data() {
    return {
      title: "控制台",
      items: [],
      userinfo: {},
      micoappCount: 0,
      loading: false,
      recentVisits: [],
    };
  },
  mounted() {
    this.title = this.$t("dashboard.text");
    this.items = [{ text: this.$t("dashboard.text"), active: true }];
    this.userinfo = JSON.parse(localStorage.getItem("user") || "{}");
    this.getMicoappCount();
    this.refreshRecentVisits();
  },
  activated() {
    this.refreshRecentVisits();
  },
  methods: {
    refreshRecentVisits() {
      this.recentVisits = getRecentVisits();
    },
    getMicoappCount() {
      if (!this.userinfo.openid) return;
      this.loading = true;
      this.$axios
        .post(
          "https://admin.aicoiot.beer/api.php",
          { action: "getmicoapplist" },
          { headers: { Openid: this.userinfo.openid } }
        )
        .then((res) => {
          this.micoappCount = Array.isArray(res.data.data) ? res.data.data.length : 0;
        })
        .catch(() => {
          this.micoappCount = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="dashboard-page">
      <div class="row">
        <!-- 欢迎区域 -->
        <div class="col-12">
          <div class="card dashboard-welcome">
            <div class="card-body">
              <div class="dashboard-welcome-inner">
                <div class="dashboard-welcome-text">
                  <h4>欢迎使用小程序管理平台</h4>
                  <p>集中管理你的小程序配置、菜单与营销设置</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 统计概览 -->
        <div class="col-12 col-md-6 col-lg-4">
          <div class="card dashboard-stat-card" @click="$router.push('/micoapp')">
            <div class="card-body">
              <div class="dashboard-stat-icon">
                <i class="ri-global-line"></i>
              </div>
              <div class="dashboard-stat-content">
                <div class="dashboard-stat-value" v-loading="loading">{{ micoappCount }}</div>
                <div class="dashboard-stat-label">小程序数量</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 最近访问 -->
        <div class="col-12" v-if="recentVisits.length > 0">
          <div class="card dashboard-recent">
            <div class="card-body">
              <h6 class="dashboard-quick-title">最近访问</h6>
              <div class="dashboard-recent-grid">
                <router-link
                  v-for="item in recentVisits"
                  :key="item.appid"
                  :to="'/micoapp/' + item.appid"
                  class="dashboard-recent-item"
                >
                  <div class="dashboard-recent-avatar">
                    <img v-if="item.head_img" :src="item.head_img" alt="">
                    <span v-else>{{ (item.niconame || '').charAt(0) }}</span>
                  </div>
                  <span class="dashboard-recent-name">{{ item.niconame }}</span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- 快捷入口 -->
        <div class="col-12">
          <div class="card dashboard-quick">
            <div class="card-body">
              <h6 class="dashboard-quick-title">快捷操作</h6>
              <div class="dashboard-quick-grid">
                <router-link to="/micoapp" class="dashboard-quick-item">
                  <i class="ri-list-check"></i>
                  <span>小程序列表</span>
                </router-link>
                <router-link to="/micoapp/create" class="dashboard-quick-item">
                  <i class="ri-add-circle-line"></i>
                  <span>创建小程序</span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.dashboard-welcome {
  border-radius: 16px;
  background: linear-gradient(135deg, #f0f7ff 0%, #e7f0ff 100%);
  border: 1px solid #e5e7eb;
}

.dashboard-welcome-inner {
  padding: 0.5rem 0;
}

.dashboard-welcome-text h4 {
  margin: 0 0 0.35rem 0;
  font-weight: 700;
  color: #1f2937;
  font-size: 1.25rem;
}

.dashboard-welcome-text p {
  margin: 0;
  color: #6b7280;
  font-size: 0.95rem;
}

.dashboard-stat-card {
  cursor: pointer;
  border-radius: 16px;
  transition: all 0.2s;
  border: 1px solid #e5e7eb;
}

.dashboard-stat-card:hover {
  border-color: #2d6cdf;
  box-shadow: 0 4px 12px rgba(45, 108, 223, 0.15);
}

.dashboard-stat-card .card-body {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.dashboard-stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: #e7f0ff;
  color: #2d6cdf;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.dashboard-stat-value {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f2937;
}

.dashboard-stat-label {
  font-size: 0.9rem;
  color: #6b7280;
}

.dashboard-recent {
  border-radius: 16px;
}

.dashboard-recent-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.dashboard-recent-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80px;
  padding: 0.75rem;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  text-decoration: none;
  color: #374151;
  transition: all 0.2s;
}

.dashboard-recent-item:hover {
  background: #e7f0ff;
  border-color: #2d6cdf;
}

.dashboard-recent-avatar {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #e5e7eb;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #2d6cdf;
  font-size: 1rem;
}

.dashboard-recent-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.dashboard-recent-name {
  font-size: 0.8rem;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.dashboard-quick {
  border-radius: 16px;
  margin-top: 0;
}

.dashboard-quick-title {
  font-weight: 600;
  color: #374151;
  margin: 0 0 1rem 0;
  font-size: 1rem;
}

.dashboard-quick-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.dashboard-quick-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  color: #374151;
  text-decoration: none;
  transition: all 0.2s;
}

.dashboard-quick-item:hover {
  background: #e7f0ff;
  border-color: #2d6cdf;
  color: #2d6cdf;
}

.dashboard-quick-item i {
  font-size: 1.25rem;
}
</style>